export default __webpack_public_path__ + "static/logo-text-white-9399be2cbfc9e4444df7c5ce3e914aa4.png";